import Nav from "@/components/marketing/Nav";
import Hero from "@/components/marketing/Hero";
import Marquee from "@/components/marketing/Marquee";
import Manifesto from "@/components/marketing/Manifesto";
import Pricing from "@/components/marketing/Pricing";
import Contact from "@/components/marketing/Contact";
import Footer from "@/components/marketing/Footer";

export default function LandingPage() {
  return (
    <main className="overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
}
